(function () {
    // Registers on the shared 'st' Angular module (see Scripts/GlobalScripts/angular-bootstrap.js).
    // The view loads this file BEFORE the body is compiled, so ng-controller="aiSearchCtrl" resolves.
    angular.module('st')
        .controller('aiSearchCtrl', [
            '$scope', '$http', '$sce',
            function ($scope, $http, $sce) {
                var vm = this;

                // ── State ────────────────────────────────────────────────────────────
                vm.endpoint = '/api/rag/search';   // same-origin proxy (RagSearchController)
                vm.placeholder = 'Search...';
                vm.query = '';
                vm.result = null;                  // the structured shape dict from the service
                vm.loading = false;
                vm.searched = false;               // true once a search has returned
                vm.errorMessage = '';
                vm.details = null;                 // film shown in the "More details" modal (null = closed)
                var reqToken = 0;                  // guards against out-of-order responses

                // ng-init in the view passes the designer values down.
                vm.init = function (endpoint, placeholder) {
                    if (endpoint) { vm.endpoint = endpoint; }
                    if (placeholder) { vm.placeholder = placeholder; }
                };

                // ── Search ───────────────────────────────────────────────────────────
                vm.search = function () {
                    var q = (vm.query || '').trim();
                    if (!q) { vm.clear(); return; }

                    var myToken = ++reqToken;
                    vm.loading = true;
                    vm.errorMessage = '';

                    $http.get(vm.endpoint, { params: { q: q } })
                        .then(function (resp) {
                            if (myToken !== reqToken) { return; }   // a newer search already fired
                            vm.result = resp.data || null;
                            vm.searched = true;
                            vm.details = null;                      // close any open details modal
                        })
                        .catch(function () {
                            if (myToken !== reqToken) { return; }
                            vm.result = null;
                            vm.errorMessage = 'Something went wrong with your search. Please try again.';
                            vm.searched = true;
                        })
                        .finally(function () {
                            if (myToken === reqToken) { vm.loading = false; }
                        });
                };

                vm.clear = function () {
                    vm.query = '';
                    vm.result = null;
                    vm.searched = false;
                    vm.errorMessage = '';
                    vm.details = null;
                };

                // Enter key in the input triggers a search.
                vm.onKey = function ($event) {
                    if ($event && $event.keyCode === 13) { vm.search(); }
                };

                // ── View helpers ───────────────────────────────────────────────────────
                // True when the current result is the given shape (keeps ng-switch simple/safe).
                vm.isShape = function (shape) {
                    return !!vm.result && vm.result.shape === shape;
                };

                // The service may hand back films with no poster; give the <img> a graceful hide.
                vm.hasResults = function () {
                    if (!vm.result) { return false; }
                    var r = vm.result;
                    return (r.films && r.films.length) ||
                           (r.showtimes && r.showtimes.length) ||
                           (r.locations && r.locations.length) ||
                           (r.sections && r.sections.length) ||
                           (r.links && r.links.length) ||
                           !!r.caption;
                };

                // Runtime minutes → "2h 52m" (or "52m" / "" ). Used by the meta line + modal.
                vm.runtimeText = function (min) {
                    min = parseInt(min, 10) || 0;
                    if (!min) { return ''; }
                    var h = Math.floor(min / 60), m = min % 60, parts = [];
                    if (h) { parts.push(h + 'h'); }
                    if (m) { parts.push(m + 'm'); }
                    return parts.join(' ');
                };

                // Compact "R · 2h 52m · Drama" line from a film object (skips empty parts).
                vm.metaLine = function (f) {
                    if (!f) { return ''; }
                    var parts = [];
                    if (f.rating) { parts.push(f.rating); }
                    var rt = vm.runtimeText(f.runtime);
                    if (rt) { parts.push(rt); }
                    if (f.genres) { parts.push(f.genres); }
                    return parts.join(' · ');
                };

                // Show "More details" only when there's something extra to reveal.
                vm.hasDetails = function (f) {
                    return !!f && (!!f.summary || !!f.cast || !!f.director);
                };

                // "More details" modal open/close.
                vm.openDetails = function (film) { vm.details = film || null; };
                vm.closeDetails = function () { vm.details = null; };

                // ── Safe HTML for film summaries (they carry <br/>, &apos;, etc.) ─────────
                // The 'st' module has no ngSanitize dependency, so we sanitize to a small
                // inline whitelist ourselves and mark the result trusted. Memoized by source
                // string so ng-bind-html doesn't see a new $sce object every digest (infdig).
                var ALLOWED_TAGS = { BR: 1, P: 1, EM: 1, STRONG: 1, B: 1, I: 1, UL: 1, OL: 1, LI: 1 };
                function sanitizeHtml(raw) {
                    var holder = document.createElement('div');
                    holder.innerHTML = String(raw);   // detached node — scripts do not execute
                    (function walk(node) {
                        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
                            if (child.nodeType !== 1) { return; }            // keep text nodes
                            var tag = child.tagName;
                            if (tag === 'SCRIPT' || tag === 'STYLE') {
                                node.removeChild(child);                     // drop entirely
                                return;
                            }
                            if (!ALLOWED_TAGS[tag]) {                        // unwrap: keep text, drop tag
                                node.replaceChild(document.createTextNode(child.textContent || ''), child);
                                return;
                            }
                            while (child.attributes.length) {                // strip all attributes
                                child.removeAttribute(child.attributes[0].name);
                            }
                            walk(child);
                        });
                    })(holder);
                    return holder.innerHTML;
                }
                var _descCache = {};
                vm.descHtml = function (raw) {
                    if (!raw) { return ''; }
                    if (!(raw in _descCache)) { _descCache[raw] = $sce.trustAsHtml(sanitizeHtml(raw)); }
                    return _descCache[raw];
                };

                // Group showtimes for display per the engine's `group_by` hint (see
                // rag-demo/SHOWTIME-GROUPING.md). The chip ALWAYS shows time + format and
                // NEVER location/date — those become headers only. Returns a uniform 2-level
                // model: [{ label, sub:[{ label, items }] }] so one template renders every
                // case (flat / single header / nested date>location).
                //   group_by "none"          → one unlabeled section (flat chip grid)
                //            "location"/"date"→ one header level
                //            "date_location"  → date outer, location inner (nested; coming_soon)
                // Cached by source-array reference so a stable input yields a stable output
                // reference (AngularJS calls this every digest — a new array each time would
                // trigger $rootScope:infdig).
                var _grpCache = { src: null, out: [] };
                function _bucket(arr, keyFn) {
                    var out = [], index = {};
                    arr.forEach(function (s) {
                        var k = keyFn(s);
                        if (!(k in index)) { index[k] = out.length; out.push({ label: k, items: [] }); }
                        out[index[k]].items.push(s);
                    });
                    return out;
                }
                vm.groupedShowtimes = function () {
                    var items = (vm.result && vm.result.showtimes) || [];
                    if (_grpCache.src === items) { return _grpCache.out; }
                    var gb = (vm.result && vm.result.group_by) || "location"; // back-compat default
                    var byDate = function (s) { return s.date_display || s.date; };
                    var byLoc = function (s) { return s.location; };
                    var out;
                    if (gb === "date_location") {
                        out = _bucket(items, byDate).map(function (d) {
                            return { label: d.label, sub: _bucket(d.items, byLoc) };
                        });
                    } else if (gb === "date") {
                        out = _bucket(items, byDate).map(function (g) {
                            return { label: g.label, sub: [{ label: "", items: g.items }] };
                        });
                    } else if (gb === "none") {
                        out = [{ label: "", sub: [{ label: "", items: items }] }];
                    } else { // "location"
                        out = _bucket(items, byLoc).map(function (g) {
                            return { label: g.label, sub: [{ label: "", items: g.items }] };
                        });
                    }
                    _grpCache.src = items;
                    _grpCache.out = out;
                    return out;
                };
            }
        ]);
})();
